import { render, staticRenderFns } from "./right.vue?vue&type=template&id=5118622a&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=5118622a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118622a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5118622a')) {
      api.createRecord('5118622a', component.options)
    } else {
      api.reload('5118622a', component.options)
    }
    module.hot.accept("./right.vue?vue&type=template&id=5118622a&scoped=true", function () {
      api.rerender('5118622a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cockpit/components/intelligence/right.vue"
export default component.exports